import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import BeatLoader from "react-spinners/BeatLoader";
import Toast from "../../Hooks/useToast";

import {
  Button,
  CustomInput,
  Description,
  SubTitle,
  UnorderedList,
} from "../../Components/CustomComponents";
import styles from "./styles/ChangePassword.module.scss";
import { useChangeUserPasswordMutation } from "../../Data/services/userApi";
import { useChangePasswordMutation } from "../../Data/services/settingApi";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";

export default function ChangePassword() {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const [changePassword, { isLoading }] = useChangePasswordMutation();

  const handleDataSubmission = async (userData) => {
    try {
      // Use unwrap() to get the response userData directly
      const response = await changePassword(userData);
      console.log(response);
      if (response.error && !response.data) {
        Toast(response.error.data.message, "error");
        return;
      }
      if (!response.error && response.data.code === 200) {
        Toast(response?.data?.message, "success");
        return;
      }
    } catch (error) {
      Toast(error?.response?.data?.message, "error");
    }
  };
  return (
    <div className={styles.ChangePassword}>
      <SubTitle text="Change Password" />
      <Description
        text="Update your password regularly to maintain account security and prevent unauthorized access."
        classes="fs-8 mb-4"
      />
      <Form onSubmit={handleSubmit(handleDataSubmission)}>
        <div className={styles.form}>
          <Description text="Current Password" classes="mb-1" />
          <Controller
            control={control}
            name="current_password"
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup>
                <CustomInput
                  placeholder="Current Password"
                  type={showPassword ? "text" : "password"}
                  onChange={onChange}
                />
                <span
                  className="input-after-icon mt-1"
                  onClick={handleShowPassword}
                >
                  {showPassword ? (
                    <FaRegEye color="black" />
                  ) : (
                    <FaRegEyeSlash color="grey" />
                  )}
                </span>
              </InputGroup>
            )}
          />
          <Description text="Set New Password" classes="mt-3 mb-1" />
          <Controller
            control={control}
            name="new_password"
            rules={{ required: "New Password is required." }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup>
                <CustomInput
                  placeholder="New Password"
                  type={showNewPassword ? "text" : "password"}
                  onChange={onChange}
                />
                <span
                  className="input-after-icon mt-1"
                  onClick={handleShowNewPassword}
                >
                  {showNewPassword ? (
                    <FaRegEye color="black" />
                  ) : (
                    <FaRegEyeSlash color="grey" />
                  )}
                </span>
              </InputGroup>
            )}
          />
          <Controller
            control={control}
            name="confirm_password"
            rules={{ required: "Confirm Password is required." }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup>
                <CustomInput
                  placeholder="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  onChange={onChange}
                />
                <span
                  className="input-after-icon mt-1"
                  onClick={handleShowConfirmPassword}
                >
                  {showConfirmPassword ? (
                    <FaRegEye color="black" />
                  ) : (
                    <FaRegEyeSlash color="grey" />
                  )}
                </span>
              </InputGroup>
            )}
          />
          <UnorderedList
            lists={[
              "At least 12 characters long but 14 or more is better.",
              "A combination of uppercase letters, lowercase letters, numbers, and symbols.",
            ]}
            classes="fs-6 mt-4 mb-4 text-black"
          />

          <div className={styles.saveButton}>
            <Button
              text={
                isLoading ? (
                  <ClipLoader color="#6457c6" size="22" />
                ) : (
                  "Change Password"
                )
              }
              classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
                isLoading || !isValid ? "bg-dark-subtle" : ""
              }`}
              disabled={isLoading || !isValid}
              type="submit"
            />
          </div>
        </div>
      </Form>
    </div>
  );
}
